
export const CHAT_STATUS = {
  COMPLETE: { key: 'COMPLETE', label: 'To be Processed', color: '#ED6C02' },
  PROCESSED: { key: 'PROCESSED', label: 'Processed', color: '#2E7D32' },
};
